var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 20.4495C35 20.7801 34.9856 21.1073 34.9573 21.4306L35 20.4495Z",
    fill: "url(#paint0_linear_144_5718)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 20.4495C35 14.3038 30.018 9.32181 23.8723 9.32181C17.7267 9.32181 12.7447 14.3038 12.7447 20.4495C12.7447 26.5951 17.7267 31.5771 23.8723 31.5771C25.1177 31.5771 25.8701 31.5094 26.9881 31.132C31.0906 29.7473 34.567 25.899 34.9573 21.4306L35 20.4495Z",
    fill: "url(#paint1_linear_144_5718)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9881 31.132L34.1944 30.7081C34.3992 30.6961 34.5617 30.5311 34.5706 30.3262L34.9573 21.4306C34.567 25.899 31.0906 29.7473 26.9881 31.132Z",
    fill: "url(#paint2_linear_144_5718)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_144_5718)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9096 27.8192C13.4963 27.8192 13.0873 27.8012 12.6832 27.7659L13.9096 27.8192Z",
    fill: "url(#paint3_linear_144_5718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9096 27.8192C21.5916 27.8192 27.8192 21.5916 27.8192 13.9096C27.8192 6.22753 21.5916 0 13.9096 0C6.22753 0 0 6.22753 0 13.9096C0 15.4662 0.0846811 16.4068 0.556383 17.8043C2.2873 22.9324 7.09769 27.2779 12.6832 27.7659L13.9096 27.8192Z",
    fill: "url(#paint4_linear_144_5718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.556383 17.8043L1.09156 26.9023C1.10361 27.1071 1.26858 27.2696 1.4735 27.2785L12.6832 27.7659C7.09769 27.2779 2.2873 22.9324 0.556383 17.8043Z",
    fill: "url(#paint5_linear_144_5718)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_144_5718)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.51119,
    cy: 14.1876,
    r: 1.94734,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_144_5718)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.075,
    cy: 14.1876,
    r: 1.94734,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_144_5718)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.6389,
    cy: 14.1876,
    r: 1.94734,
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_144_5718",
    x: 0,
    y: 0,
    width: 37.8192,
    height: 35.8193,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_144_5718"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_144_5718",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_144_5718",
    x: 3.56384,
    y: 10.2402,
    width: 11.8947,
    height: 11.8945,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_144_5718"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_144_5718",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_144_5718",
    x: 9.12767,
    y: 10.2402,
    width: 11.8947,
    height: 11.8945,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_144_5718"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_144_5718",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_144_5718",
    x: 14.6915,
    y: 10.2402,
    width: 11.8947,
    height: 11.8945,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_144_5718"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_144_5718",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_144_5718",
    x1: 15.8604,
    y1: 27.1261,
    x2: 32.3294,
    y2: 13.3278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FEFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397569,
    stopColor: "#8FEBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397669,
    stopColor: "#8FEBBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37DE87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_144_5718",
    x1: 15.8604,
    y1: 27.1261,
    x2: 32.3294,
    y2: 13.3278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FEFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397569,
    stopColor: "#8FEBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397669,
    stopColor: "#8FEBBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37DE87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_144_5718",
    x1: 15.8604,
    y1: 27.1261,
    x2: 32.3294,
    y2: 13.3278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FEFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397569,
    stopColor: "#8FEBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397669,
    stopColor: "#8FEBBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37DE87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_144_5718",
    x1: 5.56384,
    y1: 3.89468,
    x2: 22.8117,
    y2: 24.4809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#62E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#37C5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963542,
    stopColor: "#1DB5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_144_5718",
    x1: 5.56384,
    y1: 3.89468,
    x2: 22.8117,
    y2: 24.4809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#62E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#37C5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963542,
    stopColor: "#1DB5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_144_5718",
    x1: 5.56384,
    y1: 3.89468,
    x2: 22.8117,
    y2: 24.4809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#62E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#37C5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963542,
    stopColor: "#1DB5F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/Message-icon.fdfefadab8c9bf516d032f18be27c326.svg";
export { ForwardRef as ReactComponent };